import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NbDialogService, NbMediaBreakpointsService, NbMenuService, NbPopoverDirective, NbSidebarService, NbThemeService } from '@nebular/theme';

import { UserData } from '../../../@core/data/users';
import { LayoutService } from '../../../@core/utils';
import { filter, map, takeUntil } from 'rxjs/operators';
import { Subject, Observable } from 'rxjs';
import { RippleService } from '../../../@core/utils/ripple.service';
import { AuthService, UserInfo } from '../../../providers/auth.provider';
import { Router } from '@angular/router';
import { UtilitiesService } from '../../../providers/utilities.provider';
import { CONST } from '../../../providers/const';
import { LocalizationService } from '../../../modules/internationalization/localization.service';
import { AthleteService } from '../../../providers/athlete/athlete.service';
import { ClubService } from '../../../providers/club/club.service';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {
  @ViewChild(NbPopoverDirective) popover: NbPopoverDirective;

  private destroy$: Subject<void> = new Subject<void>();
  public readonly materialTheme$: Observable<boolean>;
  userPictureOnly: boolean = false;
  languageSelected = "";

  title = "";
  lastConnectionTitle = "";

  loginTitle = "";
  signupTitle = "";
  joinSTFStaffTitle = "";
  joinTalentFinderTitle = "";
  joinClubStaffTitle = "";
  userMenuChangePassword = "";
  userMenuProfile = "";
  userMenuLogout = "";

  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
    {
      value: 'material-light',
      name: 'Material Light',
    },
    {
      value: 'material-dark',
      name: 'Material Dark',
    },
  ];

  currentTheme = 'default';

  userMenu = [];
  homeMenu = [];

  username = '';
  rolename = '';
  public sportGroup = null
  public isClubStaff = false;
  lastConnection;
  isProfileCompleted = false;
  routerUrl = "";

  picture: any = 'assets/img/no-photo.png';
  isLoadingPicture = false;
  public isLoadingLogout = false;
  user: UserInfo = {} as UserInfo

  public constructor(
    private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private userService: UserData,
    private layoutService: LayoutService,
    private breakpointService: NbMediaBreakpointsService,
    private rippleService: RippleService,
    private router: Router,
    private authService: AuthService,
    private nbDialog: NbDialogService,
    private locale: LocalizationService,
    private utils: UtilitiesService,
    private athleteService: AthleteService,
    private clubService: ClubService
  ) {
    this.materialTheme$ = this.themeService.onThemeChange()
      .pipe(map(theme => {
        const themeName: string = theme?.name || '';
        return themeName.startsWith('material');
      }));
    this.routerUrl = router.url.split('/')[1];
    utils.validateProfileSideMenu.asObservable().subscribe(res => {
      this.validateProfile();
    });

    utils.validateProfilePicture.asObservable().subscribe(res => {
      this.routerUrl = router.url.split('/')[1];
      this.loadProfilePic();
    });

    utils.validateProfileName.asObservable().subscribe(res => {
      this.username = this.authService.getUserInfo().name;
    })

    utils.validateRoles.asObservable().subscribe(res => {
      this.user = res;
    })
  }

  ngOnInit() {
    let temaGuardado = localStorage.getItem(CONST.LOCALSTORAGE.theme);
    this.languageSelected = localStorage.getItem(CONST.LOCALSTORAGE.language);
    this.loadText();

    if (temaGuardado && (temaGuardado == 'material-dark' || temaGuardado == 'material-light')) {
      this.changeTheme(temaGuardado)
    } else {
      this.changeTheme('material-light');
    }

    this.currentTheme = this.themeService.currentTheme;
    const { xl } = this.breakpointService.getBreakpointsMap();

    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => {
        this.currentTheme = themeName;
        this.rippleService.toggle(themeName?.startsWith('material'));
      });

    this.menuService.onItemClick().pipe(
      filter(({ tag }) => tag === 'user-menu-context'),
      map(({ item: { title } }) => title),
    ).subscribe(title => this.onItemSelection(title));

    this.menuService.onItemClick().pipe(
      filter(({ tag }) => tag === 'home-menu-context'),
      map(({ item: { title } }) => title),
    ).subscribe(title => this.onHomeItemSelection(title));


    this.user = this.authService.getUserInfo(true);
      console.log(this.user)
    this.username = this.user && this.user.name ? this.user.name : localStorage.getItem(CONST.LOCALSTORAGE.email);

    this.rolename = this.user ? this.user.role : '';
    this.isClubStaff = this.rolename == CONST.ROLES.club_staff;
    if(this.isClubStaff && this.user.club && this.user.club.sportGroup) {
      this.sportGroup = this.user.club.sportGroup
    }

    if (this.user && this.user.jobTitle && this.user.jobTitle.value) {
      this.rolename = this.user.jobTitle.value;
    }

    this.rolename = this.rolename.replace("_", " ");
    this.lastConnection = this.user ? this.user.lastLogin ? this.user.lastLogin : new Date() : null;
    this.validateProfile();
    this.loadProfilePic();
    this.loadRoles();
  }

  loadProfilePic() {
    if (this.user && this.user.id && this.routerUrl == 'portal') {
      this.isLoadingPicture = true;
      this.athleteService.getProfilePic()
        .then((imgFile: any) => {
          if (imgFile) {
            var reader = new FileReader();
            reader.readAsDataURL(imgFile);
            reader.onloadend = (event: ProgressEvent) => {
              this.picture = reader.result;
              this.isLoadingPicture = false;
            }
          } else {
            this.picture = 'assets/img/no-photo.png';
            this.isLoadingPicture = false;
          }
        }).catch(() => {
          this.isLoadingPicture = false;
        });
    }
  }

  loadRoles() {
    if (this.user && this.user.id && this.routerUrl == 'portal' && this.user.role != CONST.ROLES.stf_staff && this.user.role != CONST.ROLES.admin) {
      this.authService.getUserRoles(this.user.id).toPromise().then((res: any) => {
        this.user.roles = res;
        this.authService.setDataSession(this.user)
      })
    }

  }

  validateProfile() {
    if (this.user && this.user.id) {
      this.isProfileCompleted = this.user.step == CONST.PROFILE_STEP.complete;
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    localStorage.setItem(CONST.LOCALSTORAGE.theme, themeName);
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

  onItemSelection(title) {
    switch (title) {
      case this.userMenuProfile:
        this.router.navigate(['/portal/profile']);
        break;
      case this.userMenuChangePassword:

        break;
      case this.userMenuLogout:
        this.isLoadingLogout = true;
        this.authService.logout()
          .finally(() => {
            this.isLoadingLogout = false;
            this.authService.clearSession();
            this.router.navigate(['/public/home']);
          })
          .then(() => { });
        break;

    }
  }

  onHomeItemSelection(title) {
    switch (title) {
      case this.loginTitle:
        this.goTo('login')
        break;
      case this.signupTitle:
        this.goTo('athlete')
        break;
      case this.joinClubStaffTitle:
        this.goTo('club')
        break;
      case this.joinTalentFinderTitle:
        this.goTo('talentFinder')
        break;
      case this.joinSTFStaffTitle:
        this.goTo('stf')
        break;

    }
  }

  selectLanguage(lang) {
    this.languageSelected = lang;
    this.locale.useLanguage(lang).then(res => {
      localStorage.setItem(CONST.LOCALSTORAGE.language, lang);
      this.loadText();
    });
  }

  loadText() {
    this.title = this.locale.translate("components.header.title");
    this.lastConnectionTitle = this.locale.translate("components.header.last_conection");
    this.loginTitle = this.locale.translate("components.header.signin");
    this.signupTitle = this.locale.translate("components.header.signup");
    this.joinSTFStaffTitle = this.locale.translate("components.header.joinAsSTFStaff");
    this.joinTalentFinderTitle = this.locale.translate("components.header.joinAsTalentFinder");
    this.joinClubStaffTitle = this.locale.translate("components.header.joinAsClubStaff");
    this.userMenuChangePassword = this.locale.translate("components.header.userMenuChangePassword");
    this.userMenuProfile = this.locale.translate("components.header.userMenuProfile");
    this.userMenuLogout = this.locale.translate("components.header.userMenuLogout");
    this.loadUserMenu();
    this.loadHomeMenu();
  }

  loadUserMenu() {
    let array = [];
    array.push({ title: this.userMenuProfile });
    array.push({ title: this.userMenuChangePassword });
    array.push({ title: this.userMenuLogout });
    this.userMenu = array;
  }

  loadHomeMenu() {
    let array = [];
    //array.push({ title: this.loginTitle });
    array.push({ title: this.signupTitle });
    /* array.push({ title: this.joinClubStaffTitle });
    array.push({ title: this.joinTalentFinderTitle });
    array.push({ title: this.joinSTFStaffTitle }); */
    this.homeMenu = array;
  }

  goTo(address: string) {
    switch (address) {
      case 'login':
        this.router.navigate(['/portal']);
        break;
      case 'athlete':
        this.router.navigate(['/public/signup/parent-athlete']);
        break;

      case 'stf':
        this.router.navigate(['/public/signup/stf']);
        break;

      case 'talentFinder':
        this.router.navigate(['/public/signup/talent-scout']);
        break;

      case 'club':
        this.router.navigate(['/public/signup/club']);
        break;
      case 'home':
        this.router.navigate(['/public/home']);
        break;
    }
  }

  onMenuSelection(event) {
    switch (event.action) {
      case 'change-role':
        UtilitiesService.showConfirmRoleDialog(this.nbDialog, event.role).then((res: any) => {
          if (res) {
            if (res.isMain) {
              this.changeMainRole(event.role)
            } else {
              this.changeRole(event.role);
            }
          }
        })
        break;
      case 'roles':
        this.router.navigate(['/portal/roles-management'], { replaceUrl: true });
        break;
      case 'profile':
        this.router.navigate(['/portal/profile'], { replaceUrl: true });
        break;
      case 'change-password':
        UtilitiesService.showChangePasswordDialog(this.nbDialog).then(res => {

        })
        break;
      case 'signout':
        this.isLoadingLogout = true;
        this.authService.logout()
          .finally(() => {
            this.isLoadingLogout = false;
            this.authService.clearSession();
            this.router.navigate(['/public/home']);
          })
          .then(() => { });
        break;
      default:
        break;
    }
    this.popover.hide();
  }

  changeRole(role) {
    this.authService.getProfileData(role).toPromise()
      .then((profileRes: any) => {
        if (profileRes.role == CONST.ROLES.club_staff && profileRes.club) {
          this.clubService.findClub(profileRes.club.id).then((res: any) => {
            profileRes.club = res;
            this.setDataSession(profileRes)
          });
        } else {
          this.setDataSession(profileRes)
        }
      })
  }

  changeMainRole(role) {
    this.authService.setMainRole(this.user.id, role).toPromise()
      .then(res => {
        this.changeRole(role);
      })
  }

  setDataSession(profileRes) {
    this.authService.setDataSession(profileRes);
    localStorage.setItem(CONST.LOCALSTORAGE.switchFlag, "1");
    window.location.reload();
  }
}
